import clsx from 'clsx';
import type { FC } from 'react';
import classes from './MapLayerOption.module.css';

export interface SelectionProps {
  selected: string;
  onChange: (value: string) => void;
}

interface Props extends SelectionProps {
  title: string;
  value: string;
  children?: React.ReactNode;
  'data-testid'?: string;
}

export const MapLayerOption: FC<Props> = ({
  title,
  value,
  selected,
  onChange,
  ...props
}) => {
  const isSelected = selected === value;
  return (
    <div
      className={clsx(classes.layerWrapper, isSelected && classes.selected)}
      data-selected={isSelected}
      data-testid={props['data-testid']}
      onClick={() => onChange(value)}
    >
      <div className={classes.optionDescription}>{title}</div>
      {props.children}
    </div>
  );
};
